import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// LIST ALL Target Goal
export const goalList = (params = '') => Http.get(`/mundo-indie-project-goals${serialize(params)}`)
export const goalCreate = (params = '') => Http.post('/mundo-indie-project-goals', params)
export const goalByID = (params = '') => Http.get(`/mundo-indie-project-goals/${params}`)
export const goalUpdate = (params = '') => Http.put(`/mundo-indie-project-goals/${params.id}`, params)
export const goalDestroy = (params = '') => Http.delete(`/mundo-indie-project-goals/${params.id}`)
